import React, { Fragment, useState } from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  NoDataFound,
} from "../../../../components/table/tableComponent";
import { HiOutlineChevronDown } from "react-icons/hi";
import TableSkeleton from "../../../../components/skeleton/tableSkeleton";

const TableHeaderData = ["Item", "Description", "Total Price"];
const tableData = [{},{},{}];

const ReceiptTable = ({ loading, search = "", onEdit = () => {} }) => {
  return (
    <Fragment>
      <Table className="">
        <TableHeader>
          <TableRow>
            {TableHeaderData.map((header, index) => (
              <TableHead
                sticky={index === TableHeaderData.length - 1}
                className="" // Removed the extra curly brace here
                key={index}
              >
                <span className="flex justify-between items-center">
                  {header}
                  {index !== 0 && index !== TableHeaderData.length - 1 && (
                    <HiOutlineChevronDown className="group-hover:text-textLight text-transparent" />
                  )}
                </span>
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>

        <TableBody>
          {loading ? (
            <TableSkeleton colSpan={TableHeaderData.length} />
          ) : tableData.length > 0 ? (
            tableData.map((data, rowIndex) => (
              <TableRow key={rowIndex} className={""}>
                <TableCell>
                  <div className="font-bold text-theme">Item Name</div>
                </TableCell>
                <TableCell>Lorem Ipsum is simply dummy text</TableCell>

                <TableCell sticky>
                  <div className="flex flex-row gap-2 items-center">500</div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <NoDataFound
                search={search}
                colSpan={TableHeaderData.length}
                text="No Data found."
              />
            </TableRow>
          )}
        </TableBody>
      </Table>
      <p className="text-theme font-bold text-right">Total Amount : N/A </p>
    </Fragment>
  );
};

export default ReceiptTable;
